import React, { useMemo } from 'react';
import './Login.css';

const LOGIN_MESSAGES = [
  'Go away', 'Hasta la vista, baby', 'Bye, Felicia', "I'll be back",
  "Frankly, my dear, I don't give a damn", 'Get busy living, or get busy dying',
  'So long, gay boys!', "Here's looking at you, kid", "You shall not pass!",
  "I'm going to make him an offer he can't refuse", "There's no place like home",
  "You can't handle the truth!", 'I see dead people', 'Houston, we have a problem',
  'Bond. James Bond.', 'You talking to me?', 'Say hello to my little friend!',
  "I'm the king of the world!", "Nobody puts Baby in a corner",
  'Life is like a box of chocolates', "You're gonna need a bigger boat",
  "I feel the need... the need for speed!", 'Show me the money!', 'Why so serious?',
  'This is Sparta!', "Roads? Where we're going, we don't need roads",
  'The Dude abides', 'That rug really tied the room together',
  'E.T. phone home', "Here's Johnny!", 'You had me at hello',
];

function Login() {
  const title = useMemo(() => LOGIN_MESSAGES[Math.floor(Math.random() * LOGIN_MESSAGES.length)], []);

  const handleLogin = () => {
    window.location.href = '/api/auth.php?action=login';
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>{title}</h1>
        <p className="login-subtitle">Private Access Only</p>
        <button className="login-button" onClick={handleLogin}>
          <img
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
            alt="Google"
            width="20"
            height="20"
          />
          Sign in with Google
        </button>
      </div>
    </div>
  );
}

export default Login;
